import { createReducer } from './create';

const initialState = {
    month_filter      : null,
    city_filter       : null,

    loading_cart      : false,
    create_cart_error : false,
};

export default createReducer(initialState, {

});
